import { drilldownData, ModuleFields } from "@utils/drilldownData";

export const fields: any = {
  users: drilldownData["users"].map(({ fieldName, placeholder, name, formType, validation, className }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
  })),
  edmMailer: drilldownData["edmMailer"].map(({ fieldName, placeholder, name, formType, validation, className }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
  })),
  notificationSettings: drilldownData["notificationSettings"].map(({ fieldName, placeholder, name, formType, validation, className }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
  })),
  newsLetter: drilldownData["newsLetter"].map(({ fieldName, placeholder, name, formType, validation, className }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
  })),
  promotions: drilldownData["promotions"].map(({ fieldName, placeholder, name, formType, validation, className }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
  })),
};
